import moment from 'moment/moment';
import 'moment/locale/ru';
import 'moment/locale/mn';
import 'moment/locale/es';
import Cookies from 'quasar/src/plugins/Cookies.js';;

const locale = (Cookies.has('locale') ? Cookies.get('locale') : 'ru') as 'ru'|'mn'|'es';

// неделя с понедельника + глобальная локаль
moment.updateLocale(locale, { week: { dow: 1 } });
moment.locale(locale);

// eslint-disable-next-line import/prefer-default-export
export { moment };
